import React from 'react';

import classNames from './style.module.scss';

const RedAsterisk = () => {
  return <span className={classNames.redAsterisk}>*</span>;
};

export default RedAsterisk;
